import React, { useContext, useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemText,
  CssBaseline,
  IconButton,
  Divider,
  useTheme,
  ListItemIcon,
  Avatar,
  Menu,
  MenuItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useMediaQuery } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import ReportIcon from "@mui/icons-material/Report";
import HelpIcon from "@mui/icons-material/Help";
import AppConfig from "../../config";
import logo from "../../assets/logo/signpost-logo.png";
import { AccountCircle, Logout, Settings } from "@mui/icons-material";
import { AuthContext } from "../../contexts/AuthContext";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { getSitesWithFilterAndPagination } from "../../services/siteServices/mainSiteService";
import axios from "axios";
import { getAllPartners } from "../../services/PartnerService/PartnerService";
import Footer from "../Footer/Footer";

const drawerWidth = 170;

const ContentWrapper = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedMenuItem, setSelectedMenuItem] = useState(null);
  const location = useLocation();
  const { user, logout, subsection, setSubsection } = useContext(AuthContext);
  const [subsectionsData, setSubsectionsData] = useState([]);
  const [projectsOpen, setProjectsOpen] = useState(true);
  const [reportsOpen, setReportsOpen] = useState(true);
  const [activeSubsection, setActiveSubsection] = useState("");
  const [filters, setFilters] = useState([
    { field: "", action: "", value: "" },
  ]);
  const navigate = useNavigate();

  const logoutNavigate = () => {
    navigate("/");
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleDrawerCloseOnItemClick = () => {
    if (isMobile) {
      setMobileOpen(false);
    }
  };
  const handleLoginClick = () => {
    // setUser(true)
    // navigate("/sign-in");
  };
  const handleProfileClick = (event) => {
    // setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleMenuItemClick = (menuItem) => {
    setSelectedMenuItem(menuItem);
    handleMenuClose();
    logout(logoutNavigate);
  };

  const handleToggle = (event, section) => {
    event.stopPropagation();
    event.preventDefault();
    if (section === "projects") {
      setProjectsOpen(!projectsOpen);
    } else if (section === "reports") {
      setReportsOpen(!reportsOpen);
    }
  };

  const getPartners = async () => {
    try {
      let res = await getAllPartners();

      const formattedSubsections = res.partner.map((item) => ({
        text: item.name,
        path: `/projects`,
      }));
      setSubsectionsData(formattedSubsections);

      if (formattedSubsections.length > 0) {
        setActiveSubsection(formattedSubsections[0].text);
      }

      // setActiveSubsection(subsectionsData[0].text);
    } catch (error) {
      console.log("error in getting partner inside content wrapper", error);
    } finally {
    }
  };

  useEffect(() => {
    getPartners();
    // console.log("-----------getting subsection data", subsectionsData[0].text);
  }, []);

  const handleSubsectionClick = async (subText) => {
    setSubsection(subText);
    setActiveSubsection(subText);
    console.log("subsection------>", subsection);
    navigate("/projects");
  };

  const drawerContent = (
    <div>
      <Toolbar />
      <Divider />
      <List>
        {[
          {
            text: "Projects",
            icon: <WorkOutlineIcon fontSize="small" />,
            subsections: subsectionsData,
          },
          {
            text: "Reports",
            icon: <ReportIcon fontSize="small" />,
            subsections: [
              { text: "City-Wise Site Status", path: "/reports" },
              // { text: "OMC-Wise Pendency Count", path: "/reports/pending" },
              {
                text: "OMC-Wise Pendency List",
                path: "/reports/stage-search",
              },
            ],
          },
          {
            text: "Master Management",
            icon: <DashboardIcon fontSize="small" />,
            path: "/mastertables",
          },
          // {
          //   text: "Help",
          //   icon: <HelpIcon fontSize="small" />,
          // },
        ].map(({ text, icon, path, subsections }) => (
          <>
            <ListItem
              dense={true}
              fontSize={"6px"}
              button
              key={text}
              component={path ? Link : "div"}
              to={path}
              onClick={
                subsections
                  ? (e) => handleToggle(e, text.toLowerCase())
                  : handleDrawerCloseOnItemClick
              }
              sx={{
                backgroundColor:
                  location.pathname == "/"
                    ? `${location.pathname}projects` === path
                      ? AppConfig.colorPalette.primary.light
                      : "transparent"
                    : `/${location.pathname.split("/")[1]}` === path
                    ? AppConfig.colorPalette.primary.light
                    : "transparent",
                "&:hover": {
                  backgroundColor: AppConfig.colorPalette.secondary.light,
                },
                alignItems: "center",
              }}
            >
              <ListItemIcon
                sx={{ minWidth: 40, color: AppConfig.colorPalette.text.dark }}
              >
                {icon}
              </ListItemIcon>
              <ListItemText
                primary={text}
                sx={{
                  fontSize: "14px",
                  ml: 0.4,
                  color: AppConfig.colorPalette.text.dark,
                }}
              />
              {subsections && (
                <span
                  onClick={(e) => handleToggle(e, text.toLowerCase())}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {text.toLowerCase() === "reports" ? (
                    reportsOpen ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )
                  ) : text.toLowerCase() === "projects" ? (
                    projectsOpen ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )
                  ) : null}
                </span>
              )}
            </ListItem>

            {subsections && reportsOpen && text === "Reports" && (
              <List component="div" disablePadding>
                {subsections.map(({ text: subText, path: subPath }) => (
                  <ListItem
                    dense
                    button
                    key={subText}
                    component={Link}
                    to={subPath}
                    onClick={handleDrawerCloseOnItemClick}
                    sx={{
                      pl: 4,
                      backgroundColor:
                        location.pathname === subPath
                          ? AppConfig.colorPalette.primary.light
                          : "transparent",
                      "&:hover": {
                        backgroundColor: AppConfig.colorPalette.secondary.light,
                        cursor: "pointer",
                      },
                      alignItems: "center",
                    }}
                  >
                    <ListItemText
                      primary={subText}
                      sx={{
                        fontSize: "12px",
                        ml: 0.4,
                        color: AppConfig.colorPalette.text.dark,
                        "&:hover": {
                          cursor: "pointer",
                        },
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            )}

            {subsections && projectsOpen && text === "Projects" && (
              <List component="div" disablePadding>
                {subsections.map(({ text: subText, path: subPath }) => (
                  <ListItem
                    dense
                    button
                    key={subText}
                    onClick={() => handleSubsectionClick(subText)}
                    sx={{
                      pl: 1,
                      backgroundColor:
                        activeSubsection === subText &&
                        !["mastertables", "reports"].some((exclude) =>
                          location.pathname.includes(exclude)
                        )
                          ? AppConfig.colorPalette.primary.light
                          : "transparent",
                      "&:hover": {
                        backgroundColor: AppConfig.colorPalette.secondary.light,
                        cursor: "pointer",
                      },
                      alignItems: "center",
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 20,
                        color: AppConfig.colorPalette.text.dark,
                      }}
                    ></ListItemIcon>
                    <ListItemText
                      primary={subText}
                      sx={{
                        fontSize: "12px",
                        ml: 0.4,
                        color: AppConfig.colorPalette.text.dark,
                        "&:hover": {
                          cursor: "pointer",
                        },
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            )}
          </>
        ))}
      </List>
    </div>
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
      }}
    >
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: AppConfig.colorPalette.primary.main,
          height: "60px",
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {isMobile && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Typography variant="h6" noWrap component="div">
            <img
              src={logo}
              alt="logo"
              style={{ marginRight: 10, height: "50px", width: "auto" }}
            />
          </Typography>
          {!isMobile && (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography color="inherit">{`Welcome, ${user?.firstName} ${user?.lastName}`}</Typography>
              <IconButton
                color="inherit"
                aria-controls="profile-menu"
                aria-haspopup="true"
                onClick={handleProfileClick}
              >
                <Avatar />
              </IconButton>
              <Menu
                id="profile-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                MenuListProps={{
                  "aria-labelledby": "profile-button",
                }}
              >
                <MenuItem
                  // onClick={() => handleMenuItemClick("Profile")}
                  selected={selectedMenuItem === "Profile"}
                  sx={{
                    "&.Mui-selected": {
                      backgroundColor: theme.palette.primary.light,
                      color: theme.palette.primary.contrastText,
                    },
                  }}
                >
                  <ListItemIcon>
                    <AccountCircle fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Profile" />
                </MenuItem>
                <MenuItem
                  // onClick={() => handleMenuItemClick("Settings")}
                  selected={selectedMenuItem === "Settings"}
                  sx={{
                    "&.Mui-selected": {
                      backgroundColor: theme.palette.primary.light,
                      color: theme.palette.primary.contrastText,
                    },
                  }}
                >
                  <ListItemIcon>
                    <Settings fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Settings" />
                </MenuItem>
                <MenuItem
                  onClick={() => handleMenuItemClick("Logout")}
                  selected={selectedMenuItem === "Logout"}
                  sx={{
                    "&.Mui-selected": {
                      backgroundColor: theme.palette.primary.light,
                      color: theme.palette.primary.contrastText,
                    },
                  }}
                >
                  <ListItemIcon>
                    <Logout fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Logout" />
                </MenuItem>
              </Menu>
            </Box>
          )}
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* Mobile Drawer */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              // backgroundColor: AppConfig.colorPalette.secondary.light,
            },
          }}
        >
          {drawerContent}
        </Drawer>

        {/* Desktop Drawer */}
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              height: `calc(100vh - 51px)`,
              // backgroundColor: AppConfig.colorPalette.secondary.light,
            },
          }}
          open
        >
          {drawerContent}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: 3,
          px: 3,
          width: {
            sm: `calc(100% - ${drawerWidth}px)`,
            xs: "100%",
          },
          minHeight: `calc(100vh - 64px)`,
          display: "flex",
          flexDirection: "column",
          position: "relative",
          paddingBottom: "80px",
          backgroundColor: "#fff",
        }}
      >
        <Toolbar />
        {children}
      </Box>
      <Box
        sx={{
          width: { xs: "100%", sm: `100%` },
          height: "50px",
          position: "fixed",
          bottom: 0,
          right: 0,
          backgroundColor: "#fff",
          borderTop: "1px solid #ddd",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: (theme) => theme.zIndex.drawer - 1,
        }}
      >
        <Footer />
      </Box>
    </Box>
  );
};

export default ContentWrapper;
